<!-- Postcontent
============================================= -->

<div class="message-form-wrapper">
  <div class="black-bg" (click)="onClose.emit(false)"></div>
  <div class="container nobottommargin message-form-container">
    <div class="close-btn" (click)="onClose.emit(false)"></div>

    <h3>YOUR CHOICE</h3>


    <div id="contact-form-result" data-notify-type="success"
         data-notify-msg="<i class=icon-ok-sign></i> Message Sent Successfully!"></div>

    <div class="nobottommargin" id="template-contactform" name="template-contactform">


      <!--===========-->
      <div class="col_half" >

        <h4>Market</h4>
        <div class="list-group">
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Market.VoiceWholesale}"
               (click)="onSelect('Market.VoiceWholesale')">
            <i [class]="smartModel.Market.VoiceWholesale ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>Voice
            wholesale
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Market.SMSHubbing}"
               (click)="onSelect('Market.SMSHubbing')">
            <i [class]="smartModel.Market.SMSHubbing ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>SMS Hubbing
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Market.EnterpriseMessaging}"
               (click)="onSelect('Market.EnterpriseMessaging')">
            <i [class]="smartModel.Market.EnterpriseMessaging ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>Enterprise
            Messaging
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Market.Custom}"
               (click)="onSelect('Market.Custom')">
            <i [class]="smartModel.Market.Custom ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>I have in mind
            something else
          </div>
          <textarea *ngIf="smartModel.Market.Custom" rows="2" cols="50" placeholder="Write here..." style="width: 100%;"
                    (ngModelChange)="onChangeSmartModel('Market.CustomText', $event)"
                    [ngModel]="smartModel.Market.CustomText"></textarea>
        </div>

        <h4>Premises</h4>
        <div class="list-group">
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Premises.SaaS}"
               (click)="onSelect('Premises.SaaS')">
            <i [class]="smartModel.Premises.SaaS ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>SaaS
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Premises.MyPremises}"
               (click)="onSelect('Premises.MyPremises')">
            <i [class]="smartModel.Premises.MyPremises ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>My premises
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.Premises.Custom}"
               (click)="onSelect('Premises.Custom')">
            <i [class]="smartModel.Premises.Custom ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>I have in mind an
            exceptional setup
          </div>
          <textarea *ngIf="smartModel.Premises.Custom" rows="2" cols="50" placeholder="Write here..." style="width: 100%;"
                    (ngModelChange)="onChangeSmartModel('Premises.CustomText', $event)"
                    [ngModel]="smartModel.Premises.CustomText"></textarea>
        </div>
      </div>
      <div class="col_half col_last">

        <h4>Payment structure</h4>
        <div class="list-group">
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.PaymentStructure.MRC}"
               (click)="onSelect('PaymentStructure.MRC')">
            <i [class]="smartModel.PaymentStructure.MRC ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>MRC
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.PaymentStructure.OneTime}"
               (click)="onSelect('PaymentStructure.OneTime')">
            <i [class]="smartModel.PaymentStructure.OneTime ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>One-time
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.PaymentStructure.InstalmentPlan}"
               (click)="onSelect('PaymentStructure.InstalmentPlan')">
            <i [class]="smartModel.PaymentStructure.InstalmentPlan ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>Instalment
            Plan
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.PaymentStructure.Custom}"
               (click)="onSelect('PaymentStructure.Custom')">
            <i [class]="smartModel.PaymentStructure.Custom ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>My
            commercial imagination is beyond standard
          </div>
          <textarea *ngIf="smartModel.PaymentStructure.Custom" rows="2" cols="50" placeholder="Write here..." style="width: 100%;"
                    (ngModelChange)="onChangeSmartModel('PaymentStructure.CustomText', $event)"
                    [ngModel]="smartModel.PaymentStructure.CustomText"></textarea>
        </div>

        <h4>Business level</h4>
        <div class="list-group">
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.BusinessLevel.HelpMeToStart}"
               (click)="onSelect('BusinessLevel.HelpMeToStart')">
            <i [class]="smartModel.BusinessLevel.HelpMeToStart ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>Help me
            to start
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.BusinessLevel.MyGrowingBusiness}"
               (click)="onSelect('BusinessLevel.MyGrowingBusiness')">
            <i [class]="smartModel.BusinessLevel.MyGrowingBusiness ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>My
            growing business needs a better solution
          </div>
          <div [ngClass]="{'list-group-item': true, 'active': smartModel.BusinessLevel.Custom}"
               (click)="onSelect('BusinessLevel.Custom')">
            <i [class]="smartModel.BusinessLevel.Custom ? 'icon-checkbox-checked' : 'icon-checkbox'"></i>I am
            exceptional, fold it all up for me
          </div>
          <textarea *ngIf="smartModel.BusinessLevel.Custom" rows="2" cols="50" placeholder="Write here..." style="width: 100%;"
                    (ngModelChange)="onChangeSmartModel('BusinessLevel.CustomText', $event)"
                    [ngModel]="smartModel.BusinessLevel.CustomText"></textarea>
        </div>
        <!--<div>-->
          <!--&lt;!&ndash;<textarea rows="2" cols="50" style="width: 100%" placeholder="Something else..."&ndash;&gt;-->
          <!--&lt;!&ndash;(ngModelChange)="onChangeModel('CustomText', $event)" [ngModel]="smartModel.CustomText"></textarea>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->

          <!--&lt;!&ndash;<div style="text-align: center">&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="button button-3d button-small button-rounded button-black"&ndash;&gt;-->
          <!--&lt;!&ndash;(click)="onApply()">Apply&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</div>-->
      </div>

      <div class="clear"></div>


      <!--===========-->

      <div class="form-process"></div>
      <h4>Please provide as much information as possible so we can best qualify your needs and make the more efficient proposition</h4>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Name) ? 'not-valid' : '')">
        <label for="template-contactform-name">Name
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-name" name="template-contactform-name" value=""
               class="sm-form-control required"
               (ngModelChange)="onChangeContactModel('Name', $event)"
               [ngModel]="contactModel.Name"/>
        <span> Enter your name </span>
      </div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Email) ? 'not-valid' : '')">
        <label for="template-contactform-email">Email
          <small>*</small>
        </label>
        <input type="email" id="template-contactform-email" name="template-contactform-email" value=""
               class="required email sm-form-control"
               (ngModelChange)="onChangeContactModel('Email', $event)"
               [ngModel]="contactModel.Email"/>
        <span> Enter your email </span>
      </div>

      <div class="col_one_third form-component col_last">
        <label for="template-contactform-phone">Phone</label>
        <input type="text" id="template-contactform-phone" name="template-contactform-phone" value=""
               class="sm-form-control"
               (ngModelChange)="onChangeContactModel('Phone', $event)"
               [ngModel]="contactModel.Phone"/>
      </div>

      <div class="clear"></div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Company) ? 'not-valid' : '')">
        <label for="template-contactform-subject">Company
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-subject" name="template-contactform-subject" value=""
               class="required sm-form-control"
               (ngModelChange)="onChangeContactModel('Company', $event)"
               [ngModel]="contactModel.Company"/>
        <span> Enter your company name </span>
      </div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Country) ? 'not-valid' : '')">
        <label for="template-contactform-subject2">Country
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-subject2" name="template-contactform-subject" value=""
               class="required sm-form-control"
               (ngModelChange)="onChangeContactModel('Country', $event)"
               [ngModel]="contactModel.Country"/>
        <span> Enter your country name </span>
      </div>


      <div class="clear"></div>

      <div [class]="'col_full form-component ' + ((notValid && !valid.Message) ? 'not-valid' : '')">
        <label for="template-contactform-message">Message
          <small>*</small>
        </label>
        <textarea class="required sm-form-control" id="template-contactform-message"
                  name="template-contactform-message" rows="6" cols="30"
                  (ngModelChange)="onChangeContactModel('Message', $event)"
                  [ngModel]="contactModel.Message">
      </textarea>
      </div>

      <div class="col_full hidden">
        <input type="text" id="template-contactform-botcheck" name="template-contactform-botcheck" value=""
               class="sm-form-control"/>
      </div>

      <div [class]="'col_full form-component ' + ((notValid && !valid.Privacy) ? 'not-valid' : '')">
        <label class="checkbox">
          <input type="checkbox" id="template-contactform-privacy"
                 name="template-contactform-privacy" value=""
                 (ngModelChange)="onChangeContactModel('Privacy', $event)"
                 [ngModel]="contactModel.Privacy"/>
          <div class="checkbox__text">I have read the <a routerLink='/privacy-notice'>Alarislabs Privacy Notice</a>
            and hereby consent to the processing of my personal data in accordance with the
            terms thereof.</div>
        </label>
        <span> Confirm reading our Privacy Notice</span>
      </div>

      <div class="col_full topmargin">
        <button class="button button-3d nomargin" id="template-contactform-submit"
                name="template-contactform-submit"
                (click)="onSubmit()" value="submit">Send Message
        </button>
      </div>

    </div>


  </div><!-- .postcontent end -->
</div>




